import React from "react";

const EngineeringIntro = ({ onBeginRegistration }) => {
    const userEmail = localStorage.getItem("userEmail");

    return (
        <div style={overlayContainer}>
            <div style={modalCard}>
                <div style={header}>
                    <span style={portalTitle}>Vendor Portal</span>
                    <span style={userEmailStyle}>{userEmail}</span>
                </div>

                <div style={content}>
                    <h1 style={welcomeTitle}>Welcome to Maamaas</h1>
                    <p style={description}>
                        Complete your engineering vendor registration to unlock the full platform.
                    </p>
                    <button 
                        style={beginButton} 
                        onClick={onBeginRegistration}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "translateY(-2px)";
                            e.currentTarget.style.boxShadow = "0 6px 20px rgba(249, 115, 22, 0.4)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "0 4px 14px 0 rgba(249, 115, 22, 0.4)";
                        }}
                    >
                        Start registration →
                    </button>
                </div>

                {/* <div style={footer}>
                    <span style={footerText}>Need help? </span>
                    <a href="#" style={helpLink}>Contact support</a>
                </div> */}
            </div>
        </div>
    );
};

export default EngineeringIntro;

const overlayContainer = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    // background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000
};

const modalCard = {
    width: "500px",
    maxWidth: "90%",
    background: "#fff",
    borderRadius: "20px",
    overflow: "hidden",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    animation: "fadeInUp 0.5s ease-out"
};

const header = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
    borderBottom: "1px solid #e5e7eb",
    background: "#fff"
};

const portalTitle = {
    fontSize: "14px",
    fontWeight: "600",
    color: "#4f46e5",
    textTransform: "uppercase",
    letterSpacing: "1px"
};

const userEmailStyle = {
    fontSize: "12px",
    color: "#6b7280",
    background: "#f3f4f6",
    padding: "4px 12px",
    borderRadius: "20px"
};

const content = {
    padding: "48px 32px",
    textAlign: "center"
};

const welcomeTitle = {
    fontSize: "28px",
    fontWeight: "700",
    marginBottom: "12px",
    // background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    color: "#667eea"
};

const description = {
    fontSize: "15px",
    color: "#6b7280",
    lineHeight: "1.5",
    marginBottom: "32px"
};

const beginButton = {
    background: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
    color: "#fff",
    padding: "12px 28px",
    borderRadius: "40px",
    border: "none",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "15px",
    transition: "transform 0.2s, box-shadow 0.2s",
    boxShadow: "0 4px 14px 0 rgba(249, 115, 22, 0.4)"
};

const footer = {
    padding: "16px 24px",
    borderTop: "1px solid #e5e7eb",
    textAlign: "center",
    background: "#f9fafb"
};

const footerText = {
    fontSize: "12px",
    color: "#6b7280"
};

const helpLink = {
    fontSize: "12px",
    color: "#f97316",
    textDecoration: "none",
    fontWeight: "500",
    cursor: "pointer"
};

const animationStyle = document.createElement("style");
animationStyle.textContent = `
    @keyframes fadeInUp {
        from { opacity: 0; transform: translateY(30px); }
        to { opacity: 1; transform: translateY(0); }
    }
`;
if (!document.querySelector("#eng-intro-animation")) {
    animationStyle.id = "eng-intro-animation";
    document.head.appendChild(animationStyle);
}